import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('');
const ZA_IMG = {
    L1: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711680465988/r2p_l1_1366_za.jpg',
    L2: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711680848430/r2p_l2_1366_za.jpg',
    L3: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711680870853/r2p_l3_1366_za.jpg',
};

export default function L() {
    const { useEffect, useLang, useRouter } = useGlobal();
    const { t } = useLang('productriver2');
    const { locale } = useRouter();

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
        const layoutH = typeof window !== 'undefined' ? window?.innerHeight : 1042;
        new ScrollMagic.Scene({
            triggerElement: '.river2_detials_L',
            triggerHook: 1,
            offset: layoutH,
        })
            .setClassToggle('.river2_detials_L', 'enter')
            .addTo(controller);
    }, []);

    return (
        <div className={`${css.L_12} river2_detials_L`}>
            <div className={`sticky-wrapper`}>
                <div className="title-wrapper">
                    <div className="title-green">{t('river2.details.sec12_title')}</div>
                    <div className="title-animation-wrapper">
                        <div className="title-animation">
                            <div className="title2">{t('river2.details.sec12_title2')}</div>
                            <div className="title1">{t('river2.details.sec12_title1')}</div>
                        </div>
                    </div>
                </div>
                <div className="imgsList">
                    <div className="img-wrapper img-1">
                        <EFPic
                            name={
                                locale === 'ph'
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1751081534244/1.jpg'
                                    : locale === 'za'
                                    ? ZA_IMG.L1
                                    : ['/media/river2/pc/L1.webp', '/media/river2/pc/L1.jpg']
                            }
                            className="imgs"
                            alt={t('river2.details.sec12_title')}
                            aria-label={t('river2.details.sec12_title')}
                        />
                    </div>
                    <div className="img-wrapper img-2">
                        <EFPic
                            name={
                                locale === 'ph'
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1751081388129/2.jpg'
                                    : locale === 'za'
                                    ? ZA_IMG.L2
                                    : ['/media/river2/pc/L2.webp', '/media/river2/pc/L2.jpg']
                            }
                            className="imgs"
                            alt={t('river2.details.sec12_title')}
                            aria-label={t('river2.details.sec12_title')}
                        />
                    </div>
                    <div className="img-wrapper img-3">
                        <EFPic
                            name={
                                locale === 'ph'
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1751081387950/3.jpg'
                                    : locale === 'za'
                                    ? ZA_IMG.L3
                                    : ['/media/river2/pc/L3.webp', '/media/river2/pc/L3.jpg']
                            }
                            className="imgs"
                            alt={t('river2.details.sec12_title')}
                            aria-label={t('river2.details.sec12_title')}
                        />
                    </div>
                </div>
                {locale === 'kr' && (
                    <div className="product-detail">
                        <div className="title">{t('river2.details.sec12_title3')}</div>
                        <div className="img-wrapper">
                            <EFPic
                                name={'/media/river2/pc/L_river2_details.png'}
                                className="fullImgs"
                                alt={t('river2.details.sec12_title3')}
                                aria-label={t('river2.details.sec12_title3')}
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
